import React from 'react';
import { MdAdd, MdEdit } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import '../styles/views.css';

const PaymentMethodsView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  setIsAddModalOpen,
  setEditPaymentMethod,
  setIsEditModalOpen,
}) => {
  return (
    <>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <input
          type="text"
          placeholder="Search payment methods..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{
            width: 300,
            padding: '8px 12px',
            borderRadius: 4,
            border: '1px solid #ccc',
            fontSize: 16,
            outline: 'none',
          }}
        />

      </div>
      <div style={{ marginBottom: 24, boxShadow: '0 2px 8px rgba(0,0,0,0.1)', borderRadius: 8, backgroundColor: '#fff',
        scrollbarWidth: 'thin',
        scrollbarColor: '#1976d2 #e0e0e0',
        maxWidth: 'calc(100% - 20px)',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}>
 
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            {pagedFilteredData.map((row, i) => (
              <tr key={i} style={{ cursor: 'default' }}>
                <td>{row.name}</td>
                <td>{row.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {pageCount > 1 && (
        <ReactPaginate
          previousLabel={'previous'}
          nextLabel={'next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          activeClassName={'active'}
        />
      )}
    </>
  );
};

export default PaymentMethodsView;